import { render, staticRenderFns } from "./Peo.vue?vue&type=template&id=746010bb&scoped=true&"
import script from "./Peo.vue?vue&type=script&lang=js&"
export * from "./Peo.vue?vue&type=script&lang=js&"
import style0 from "../../assets/democss/peo.css?vue&type=style&index=0&id=746010bb&scoped=true&lang=css&"
import style1 from "../../assets/css/orgdetails.css?vue&type=style&index=1&id=746010bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746010bb",
  null
  
)

export default component.exports